import { getAvailableHours_adapter } from "@Adapters/employee/getAvailableHours.adapter";
import { getAppointmentById_adapter } from "@Adapters/reserve/getAppointmentById.adapter";
import { useEffect } from "react";

export const useAdaptReserveDetail = (
  reserveId,
  setStateResponse,
  setCustomerSelected,
  setSelectedItems,
  setIsLoadingDetail,
  setInitialSelectItems,
  generateId,
  setStatusReserve,
  setInitialStatusReserve,
  setInitialSelectCustomer,
  setAvailableHours,
  setLoadingHours,
  setLoadingHoursId,
  setDateReservation,
  setAditionalComments,
  setInitialComments,
  setInitialDateReservation = (_date: string) => {}
) => {
  useEffect(() => {
    const getReserveDetail = async () => {
      if (!reserveId) return;
      setIsLoadingDetail(true);
      try {
        const response = await getAppointmentById_adapter(reserveId);
        if (response.isSuccess) {
          // nueva reserva
          if (!reserveId) {
            const existingItem = {
              id: generateId(),
              service: "",
              employee: "",
              schedule: "",
            };
            setSelectedItems([existingItem]);
            return;
          }
          // reserva existente
          setLoadingHours(true);
          setIsLoadingDetail(true);
          const responseAppointment = await getAppointmentById_adapter(
            reserveId
          );

          if (!responseAppointment.isSuccess) {
            setStateResponse({
              status: 400,
              message: responseAppointment.message,
            });
            return;
          }
          const formatDate = (date: string) => {
            const [day, month, year] = date.split("/");
            return `${year}-${month}-${day}`;
          };
          // TRABAJO
          setInitialSelectItems(responseAppointment.data.services);
          setSelectedItems(responseAppointment.data.services);
          setCustomerSelected(responseAppointment.data.client);
          setInitialSelectCustomer(responseAppointment.data.client);
          setStatusReserve(responseAppointment.data.statusReserve);
          setInitialStatusReserve(responseAppointment.data.statusReserve);
          const reserveDateFormatted = formatDate(
            responseAppointment.data.dateReserve
          );
          setDateReservation(reserveDateFormatted);
          setInitialDateReservation(reserveDateFormatted);
          // por cada servicio, va a tomar el id del empleado y va a hacer un get de los horarios disponibles y se le va a asignar el id del item

          // Obtener horarios disponibles para cada servicio
          const availableHoursData = {};
          for (const service of responseAppointment.data.services) {
            setLoadingHoursId(service.id);
            const hoursResponse = await getAvailableHours_adapter({
              // Usar la fecha de la reserva (no la de hoy): la disponibilidad
              // depende del día de la semana del turno del empleado. Pedirla
              // con "hoy" devolvía [] si el empleado no atiende hoy y dejaba el
              // selector de hora solo con la hora original de la reserva.
              date: reserveDateFormatted,
              employeeId: service.employee,
              priceServiceId: service.service,
              reserveId: reserveId,
            });
            setLoadingHoursId(null);

            // Asignar solo los horarios disponibles al id del servicio
            availableHoursData[service.id] = hoursResponse.data; // Cambiado para solo obtener los horarios
          }
          setAvailableHours(availableHoursData); // Setear los horarios disponibles
          setIsLoadingDetail(false);
          setLoadingHours(false);

          // Asegurarnos de que los comentarios se manejen correctamente
          const observation = responseAppointment.data.observation || "";
          setAditionalComments(observation);
          setInitialComments(observation);
        }
      } catch (error) {
        // ... manejo de errores ...
      } finally {
        setIsLoadingDetail(false);
      }
    };
    getReserveDetail();
  }, [reserveId]);
};
